// Small "via <provider>" label surfaced next to AI-generated content.
// Quality genuinely varies between e.g. Groq's free model and GPT-4o -- this
// makes that visible/debuggable instead of silent, without being loud about it.
const PROVIDER_LABELS = {
  groq: 'Groq',
  deepseek: 'DeepSeek',
  openai: 'OpenAI',
  pollinations: 'Pollinations',
  together: 'Together AI',
  fal: 'Fal.ai',
};

const ProviderBadge = ({ provider, className = '' }) => {
  if (!provider) return null;
  const label = PROVIDER_LABELS[provider] || provider;
  return (
    <span className={`text-[10px] uppercase tracking-wide text-muted-foreground/60 ${className}`}>
      via {label}
    </span>
  );
};

export default ProviderBadge;
